/* eslint-disable no-shadow */
// Doc: https://www.hubrise.com/fr/developers/api/order-management/#order-status
export enum HubriseOrderStatus {
    new = 'new',
    received = 'received',
    accepted = 'accepted',
    in_preparation = 'in_preparation',
    awaiting_shipment = 'awaiting_shipment',
    awaiting_collection = 'awaiting_collection',
    in_delivery = 'in_delivery',
    completed = 'completed',

    rejected = 'rejected',
    cancelled = 'cancelled',
    delivery_failed = 'delivery_failed'
}
